/* eslint-disable react/prop-types */
import React, { Component } from "react";
import {
  Grid, Segment,
  Button, Divider, Dimmer, Loader,
  Container
} from "semantic-ui-react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { changeRouteAction } from "actions/changeActiveItemActions";
import Constants from "utilities/Constants";
import Strings from "utilities/StringSelector";
import Utils from "utilities/Utils";


const UtilsInstance = new Utils();

class AnalyzerDPConfiguration extends Component {

  // Intialize this component state
  constructor(props) {
    super(props);
    this.state = {
      tag: "",
      isResetLogDimmerActive: false,
      idleSize: 1,
      packetSize: 1,
      isIdleSizeDimmerActive: false,
      isIdleSizeModalOpen: false,
      isPacketSizeDimmerActive: false,
      isPacketSizeModalOpen: false,
      updateStatus: Constants.NOT_UPDATING,
    };
    this.packetSizeUpdateLoaderRef = React.createRef();
    this.idleSizeUpdateLoaderRef = React.createRef();
  }


  showResetLogDimmer = () => this.setState({ isResetLogDimmerActive: true });
  hideResetLogDimmer = () => this.setState({ isResetLogDimmerActive: false });

  cleanLog = () => {
    let data = JSON.stringify({
      reset: "True"
    });

    this.showResetLogDimmer();

    fetch(Constants.MONITOR_REQUEST_IP_ADDRESS + "resetLog_POST/fisic", {
      method: "POST",
      headers: {
        "Content-Type": "application/json;charset=UTF-8"
      },
      body: data
    }).then(UtilsInstance.checkStatus)
      .then(() => {
        alert(Strings.CLEAN_LOG_SUCCESS);
      })
      .catch((error) => {
        alert(Strings.CLEAN_LOG_FAILURE + Strings.REASON + error);
      })
      .finally(this.hideResetLogDimmer);
  }

  // segmentDevices = () => {
  //   this.props.onChangeRoute(
  //     this.props.currGenConfigComponent,
  //     this.props.currProtConfigComponent,
  //     "segment-devices"
  //   );
  // }

  render() {
    const isResetLogDimmerActive = this.state.isResetLogDimmerActive;

    return (
      <Container>

        <Grid columns={1} doubling>
          <Grid.Column>
            <Segment style={updateSegmentStyle}>
              <Divider horizontal>{Strings.LOG}</Divider>
              <Button color="teal" onClick={this.cleanLog}>{Strings.CLEAR}</Button>
              <Dimmer active={isResetLogDimmerActive} >
                <Loader>{Strings.WAITING}</Loader>
              </Dimmer>
            </Segment>
          </Grid.Column>
        </Grid>

      </Container >
    );
  }
}

const mapActionsToProps = {
  onChangeRoute: changeRouteAction,
};

const mapStateToProps = state => ({
  currGenConfigComponent: state.configRoutes.currGenConfigComponent,
  currProtConfigComponent: state.configRoutes.currProtConfigComponent,
  currAnDPConfigComponent: state.configRoutes.currAnDPConfigComponent,
});

const updateSegmentStyle = {
  textAlign: "center"
};


export default connect(mapStateToProps, mapActionsToProps)(withRouter(AnalyzerDPConfiguration));
